import ABSUtils from '@abs/utils/ABSUtils';
import i18next from 'i18next';
import NodeRSA from 'node-rsa';
import Cookies from 'universal-cookie';
import format from 'date-fns/format';
import { requestNativePushTokenOnly } from '../nativePushNotifications';
/* eslint-disable camelcase */
import { enGB, de as deAT } from "date-fns/locale"; // import all locales we need
const locales = { enGB, deAT }; // used to look up the required locale

const nodeCrypto = require('crypto-browserify');
const userLocalIpUrl = require('local-ip-url');
var userPlatform = require('platform');
const cookies = new Cookies();

//error definitions
const success_general = { returnnumber: 0, returncontent: "ok" };
const showonlytheerrortext = -1;
const app_error_general = { returnnumber: 1000, returncontent: "abswebservice:ERROR_GENERAL" };
const app_error_servercertificateretrieve = { returnnumber: 1001, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_servercertificatemissing = { returnnumber: 1002, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_genereatekeyandiv = { returnnumber: 1004, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_encryption = { returnnumber: 1005, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_decryption = { returnnumber: 1006, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_communicationhandlercrash = { returnnumber: 1007, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_communicationhandlerbusy = { returnnumber: 1008, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_communicationrerror = { returnnumber: 1009, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_unknownserverresponse = { returnnumber: 1010, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_serverresponsecrash = { returnnumber: 1011, returncontent: "abswebservice:ERROR_PROCESSINGDATA" };
const app_error_createorvalidatecrash = { returnnumber: 1012, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_createorvalidatefailure = { returnnumber: 1013, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_sessionnotexist = { returnnumber: 1014, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };
const app_error_sessionexpired = { returnnumber: 1015, returncontent: "abswebservice:ERROR_ESTABLISHCONNECTION" };

const co_error_deviceversion = { returnnumber: 311, returncontent: "abswebservice:ERROR_APIVERSIONMISMATCH" };

const deviceversion = "1.0.13", deviceversionbuild = "1", deviceplatform = "absweb";
const webserviceversion_server = "1.0.13", webserviceversion_broker = "1.0.3";
const serverapifile = "api.php", brokerapifile = "api.php";
const Broker1URL = 'https://grey.businesssuite.cloud';
// const Broker2URL = 'https://white.businesssuite.cloud'; //not set yet

var prgname = "";
var currSessData = null;
var serverresponse_waiting = false;

class absWebService extends ABSUtils.EventEmitter {
	constructor(props) {
		super(props);

		this.resetSessionUserData();
	}

	init() {
		var b = this.checkOtherPlatform();
		//this.setInterceptors();
		this.handleAuthentication();
	}

	checkOtherPlatform = () => {
		var nativeapp = this.getAppRestrictionCookie();
		switch (nativeapp) {
			case "abs":
				prgname = "ABS App";
				break;
			case "tl":
				prgname = "TimeLite App";
				break;
			case "eo":
				prgname = "Exkursio App";
				break;
			default:
				prgname = "ABS Web";
				break;
		}

		return true;
	}

	// setInterceptors = () => {
	// 	axios.interceptors.response.use(
	// 		response => {
	// 			return response;
	// 		},
	// 		err => {
	// 			return new Promise((resolve, reject) => {
	// 				if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
	// 					// if you ever get an unauthorized response, logout the user
	// 					this.emit('onAutoLogout', i18next.t("abswebservice:SERVERBADRESPONSE"));
	// 					this.logout();
	// 				}
	// 				throw err;
	// 			});
	// 		}
	// 	);
	// };

	handleAuthentication = async () => {
		const accesstokencookie = this.getAccessTokenCookie();

		if (!accesstokencookie) {
			this.emit('onNoAccessToken');
			return;
		}

		var resp = await this.isTokenAndCompanyValid(accesstokencookie)
			.catch(errorresponse => {
				return errorresponse;
			});

		if (resp === true) {
			this.emit('onAutoLogin', true);
		}
		else if (resp === false) {
			this.emit('onAutoLogout', i18next.t("abswebservice:SESSIONEXPIRED") + "...");
		}
		else {
			this.emit('onErrorOccured', resp);
		}
	};

	aes_encrypt = ((msg, key, iv, readme = true) => {
		try {
			var key_bytes = Buffer.from(key, "base64");
			var iv_bytes = Buffer.from(iv, "base64");
			let cipher = nodeCrypto.createCipheriv('aes-256-cbc', key_bytes, iv_bytes);

			if (readme) {
				msg = "~readme~" + msg;
			}

			let encrypted = cipher.update(msg, 'utf8', 'base64');
			encrypted += cipher.final('base64');
			return this.makeSuccessArr(encrypted);
		}
		catch (error) {
			return app_error_encryption;
		}
	});
	aes_decrypt = ((encrypted, key, iv, readme = true, needextras = true) => {
		try {
			var key_bytes = Buffer.from(key, "base64");
			var iv_bytes = Buffer.from(iv, "base64");
			let decipher = nodeCrypto.createDecipheriv('aes-256-cbc', key_bytes, iv_bytes);

			let decrypted_ = decipher.update(encrypted, 'base64', 'utf8');

			var decrypted = (decrypted_ + decipher.final('utf8'));

			if (readme) {
				if (decrypted.startsWith("~readme~")) {
					decrypted = decrypted.replace("~readme~", "");

					if (needextras && currSessData.sessionrsakeypair != null) {
						var splitarr = decrypted.split(":::");

						//decode base64 return
						decrypted = Buffer.from(splitarr[0], 'base64').toString("utf8");

						//decode keyiv infos
						var nextkeyivwithdate_arr = this.rsa_decrypt(splitarr[1], currSessData.sessionrsakeypair.privkey);

						//only if success - here maybe rethink to give back an error
						if (this.isResponseArrSuccess(nextkeyivwithdate_arr)) {
							var nextkeyivwithdate = JSON.parse(this.getDataFromResponseArr(nextkeyivwithdate_arr));

							//nextkeyivwithdate.srv_time

							//store backend version if available
							if (nextkeyivwithdate.srv_version) {
								currSessData.backendversion = nextkeyivwithdate.srv_version;
							}

							//store system messages if available
							if (nextkeyivwithdate.systemmessages) {
								currSessData.systemmessages = nextkeyivwithdate.systemmessages;
							} else {
								currSessData.systemmessages = [];
							}

							//emit event to update system messages
							this.emit('onSystemMessagesUpdate', currSessData.systemmessages);

							//set next key and iv (must happen BEFORE emitting notification events
							//to prevent stale-key race conditions with triggered API calls)
							currSessData.currkeyiv = { key: nextkeyivwithdate.nextkey, iv: nextkeyivwithdate.nextiv };

							//save key change to cookies
							if (this.getSessionCookie() != null) {
								this.setSessionCookie(currSessData.sessionid, currSessData.sessionrsakeypair, currSessData.currkeyiv, currSessData.sessionexpire);
							}

							//store and emit unread notification count if available
							if (nextkeyivwithdate.unread_notifications !== undefined) {
								currSessData.unread_notifications = nextkeyivwithdate.unread_notifications;
								this.emit('onUnreadNotificationsUpdate', currSessData.unread_notifications);
							}
						}
					}
				}
				else {
					return app_error_decryption;
				}
			}

			return this.makeSuccessArr(decrypted);
		}
		catch (error) {
			return app_error_decryption;
		}
	});

	rsa_encrypt = ((msg, pubkey) => {
		try {
			const rsa = new NodeRSA(pubkey);
			var rsaresult = rsa.encrypt(btoa(msg), 'base64', 'base64');
			return this.makeSuccessArr(rsaresult);
		}
		catch (error) {
			return app_error_encryption;
		}
	});
	rsa_decrypt = ((msg, privkey) => {
		try {
			const rsa = new NodeRSA(privkey);
			var rsaresult = rsa.decrypt(msg, 'utf8', 'utf8');
			return this.makeSuccessArr(rsaresult);
		}
		catch (error) {
			return app_error_decryption;
		}
	});
	rsa_generate_keypair = (async () => {
		try {
			//this is very inefficient, takes really long
			// const rsa = new NodeRSA();
			// await rsa.generateKeyPair(2048);
			// var privkey = rsa.exportKey('pkcs1-private');
			// var pubkey = rsa.exportKey('pkcs1-public');

			//this is far better in performance
			const rsa = new NodeRSA();
			var keypair = await window.crypto.subtle.generateKey(
				{
					name: "RSA-OAEP",
					modulusLength: 2048,
					publicExponent: new Uint8Array([1, 0, 1]), // Equivalent to 65537
					hash: "SHA-256"
				},
				true,
				["encrypt", "decrypt"]
			);
			const exported_priv = await window.crypto.subtle.exportKey(
				"pkcs8",
				keypair.privateKey
			);
			const exported_privAsString = String.fromCharCode.apply(null, new Uint8Array(exported_priv));
			const exported_privAsBase64 = btoa(exported_privAsString);
			const privkey_pkcs8 = `-----BEGIN PRIVATE KEY-----${exported_privAsBase64}-----END PRIVATE KEY-----`;
			rsa.importKey(privkey_pkcs8, 'pkcs8');
			var privkey = rsa.exportKey('pkcs1-private');
			//since we can det the public key from the private one, this below is just for full docu
			// const exported_pub = await window.crypto.subtle.exportKey(
			// 	"spki",
			// 	keypair.publicKey
			// );
			// const exported_pubAsString = String.fromCharCode.apply(null, new Uint8Array(exported_pub));
			// const exported_pubAsBase64 = btoa(exported_pubAsString);
			// const pubkey_pkcs8 = `-----BEGIN PUBLIC KEY-----${exported_pubAsBase64}-----END PUBLIC KEY-----`;
			// rsa.importKey(pubkey_pkcs8, 'pkcs8-public-pem');
			var pubkey = rsa.exportKey('pkcs1-public');

			var rsakeypair = { privkey: privkey, pubkey: pubkey };
			return rsakeypair;
		}
		catch (error) {
			return null;
		}
	});
	aes_generate_key_and_iv = (() => {
		try {
			//generate secret password
			let secretpassphrase = nodeCrypto.randomBytes(32);
			//Create sha256 hash
			const key = nodeCrypto.createHmac('sha256', secretpassphrase).digest('base64');
			//Create iv
			let iv = nodeCrypto.randomBytes(16).toString('base64');

			var keyandiv = { key: key, iv: iv };
			return keyandiv;
		}
		catch (error) {
			return null;
		}
	});
	rsa_aes_encrypt = ((msg) => {
		try {
			if (currSessData.serverrsakey != null) {
				var aes_ = this.aes_generate_key_and_iv();
				if (aes_ != null) {
					//encrypt data with new aes key
					var edata = this.aes_encrypt(msg, aes_.key, aes_.iv);
					if (!this.isResponseArrSuccess(edata))
						return edata;

					//encrypt aes key and iv with rsa 
					var eaes = this.rsa_encrypt(JSON.stringify(aes_), currSessData.serverrsakey.pub_key);
					if (!this.isResponseArrSuccess(eaes))
						return eaes;

					//combine both and return
					var rtn = this.getDataFromResponseArr(eaes) + ":::" + this.getDataFromResponseArr(edata);
					return this.makeSuccessArr(rtn);
				}
				else {
					return app_error_genereatekeyandiv;
				}
			}
			else {
				return app_error_servercertificatemissing;
			}
		}
		catch (error) {
			return app_error_encryption;
		}
	});

	//first get the url from broker, then the infos and the public key from server
	getCompanyInfosAndPubKey = (company) => {
		return new Promise(async (resolve, reject) => {

			//to be sure reset all current data
			this.resetSessionUserData();

			//get the infos from broker
			var brokerresponse = await this.communicateWithWebserver("get_company_forward", company, null, null, true)
				.catch(errorresponse => {
					reject(this.getDisplayTextFromResponseArr(errorresponse));
				});

			//.then alternative
			if (brokerresponse != null) {
				if (this.isResponseArrSuccess(brokerresponse)) {
					var rspcompany = this.getDataFromResponseArr(brokerresponse);

					if (rspcompany.startsWith("{\"Company_Short\":")) {
						//success
						currSessData.usercompany = JSON.parse(rspcompany);

						//now get publickey with servertime and companyrealname
						var datetime = format(new Date(), "yyyy-MM-dd' 'HH:mm:ss");
						var apidata = btoa(datetime);

						var localtimebefore = new Date();
						var serverresponse = await this.communicateWithWebserver("get_servertime_and_pubkey", company, null, apidata)
							.catch(errorresponse => {
								reject(this.getDisplayTextFromResponseArr(errorresponse));
							});
						var localtimeafter = new Date();

						//.then alternative
						if (serverresponse != null) {
							if (this.isResponseArrSuccess(serverresponse)) {
								var rspsrv = this.getDataFromResponseArr(serverresponse);
								if (rspsrv.startsWith("{\"srv_time\":")) {
									var rspsrv_arr = JSON.parse(rspsrv);

									var servertime = ABSUtils.NewDate(rspsrv_arr.srv_time);
									//because it is milliseconds we multiply and round it to seconds
									var transmissiontime = Math.round((localtimeafter - localtimebefore) / 1000);

									var realdiff = Math.round(((servertime - localtimeafter) - transmissiontime / 2) / 1000);

									currSessData.servertolocaltimediff = realdiff;

									currSessData.serverrsakey = JSON.parse(rspsrv_arr.rsa_keyinfos);

									currSessData.usercompany.companyrealname = rspsrv_arr.companyrealname;
									currSessData.usercompany.companylogo = rspsrv_arr.companylogo;

									rspcompany = { companyshortname: currSessData.usercompany.Company_Short, companyrealname: currSessData.usercompany.companyrealname };
									resolve(rspcompany);
								}
								else {
									reject(this.getDisplayTextFromResponseArr(app_error_servercertificateretrieve));
								}
							}
							else {
								reject(this.getDisplayTextFromResponseArr(serverresponse));
							}
						}
					}
					else {
						//it can only be "nodata"
						resolve(rspcompany);
					}
				}
				else {
					reject(this.getDisplayTextFromResponseArr(brokerresponse));
				}
			}
		});
	};

	generatePasswordHash = async (password) => {
		//create valid sha512 hash
		var passwordhashbuf = await window.crypto.subtle.digest("SHA-512", new TextEncoder("utf-8").encode(password));
		var passwordhash = Array.prototype.map.call(new Uint8Array(passwordhashbuf), x => (('00' + x.toString(16)).slice(-2))).join('');

		return passwordhash;
	}

	signInWithUsernameAndPassword = (username, password, keeplogin) => {
		return new Promise(async (resolve, reject) => {
			//create hash of password
			var passwordhash = await this.generatePasswordHash(password);
			//now create hahs of passwordhash
			var passwordhash_hash = await this.generatePasswordHash(passwordhash);

			if (currSessData != null && currSessData.sessionrsakeypair != null && currSessData.currkeyiv != null && currSessData.sessionid != null) {
				var sessionresp = await this.validateSession(username, passwordhash_hash, "Password_Hash_Hash_SHA512", keeplogin); //use keeplogin to determine if generate accesstoken
			}
			else {
				var sessionresp = await this.createAndValidateSession(username, passwordhash_hash, "Password_Hash_Hash_SHA512", keeplogin); //use keeplogin to determine if generate accesstoken
			}

			if (this.isResponseArrSuccess(sessionresp)) {
				if (keeplogin) {
					this.setSessionCookie(currSessData.sessionid, currSessData.sessionrsakeypair, currSessData.currkeyiv, currSessData.sessionexpire);
					this.setAccessTokenCookie(currSessData.auth.username, currSessData.auth.accesstoken, currSessData.auth.accesstokenexpire);
				}

				// Save successful login to history for autocomplete suggestions
				this.saveLoginToHistory(currSessData.usercompany.Company_Short, username);

				var userinfos = JSON.parse(this.getDataFromResponseArr(sessionresp));
				userinfos.CompanyShortName = currSessData.usercompany.Company_Short;
				userinfos.CompanyName = currSessData.usercompany.companyrealname;
				userinfos.CompanyLogo = currSessData.usercompany.companylogo;

				//set allowed modules
				userinfos.modules = this.setAllowedModules(userinfos);
				this.emit('onLogin', userinfos);
				//return the userinfos with modules
				resolve(userinfos);
			}
			else {
				reject(this.getDisplayTextFromResponseArr(sessionresp));
			}
		});
	};

	signInWithNFCChip = (chiptext, serialnumber, emulate = false) => {
		return new Promise(async (resolve, reject) => {
			var sessionresp = await this.createAndValidateSession(chiptext, serialnumber, "NFC Card/Chip/Tag", false);

			if (this.isResponseArrSuccess(sessionresp)) {
				var userinfos = JSON.parse(this.getDataFromResponseArr(sessionresp));
				userinfos.CompanyShortName = currSessData.usercompany.Company_Short;
				userinfos.CompanyName = currSessData.usercompany.companyrealname;
				userinfos.CompanyLogo = currSessData.usercompany.companylogo;

				//set allowed modules
				userinfos.modules = this.setAllowedModules(userinfos);

				//chip login specific
				userinfos.Autologout = new Date(new Date().getTime() + 1000 * 120); //120 seconds
				userinfos.LogoutAfterAction = true;

				//if chipinfo, then skip this, we dont want an actual login
				if (!emulate)
					this.emit('onLogin', userinfos);

				//return the userinfos with modules
				resolve(userinfos);
			}
			else {
				reject(this.getDisplayTextFromResponseArr(sessionresp));
			}
		});
	};

	isSessionValid = () => {
		if (currSessData != null && currSessData.sessionrsakeypair != null && currSessData.currkeyiv != null && currSessData.sessionid != null) {
			//refetch sessioncookie if multiple windows in one browser are open it could be different already
			const sessioncookie = this.getSessionCookie();
			if (sessioncookie) {
				var abssession = JSON.parse(Buffer.from(sessioncookie, 'base64').toString("utf8"));
				currSessData.sessionid = abssession.sessionid;
				currSessData.sessionexpire = new Date(abssession.sessionexpire);
				currSessData.sessionrsakeypair = abssession.sessionrsakeypair;
				currSessData.currkeyiv = abssession.currkeyiv;
			}

			return true;
		}
		else {
			return false;
		}
	}

	createSession = async () => {
		var recycleoldsessionid = null;

		var aeskeyandiv = this.aes_generate_key_and_iv();
		currSessData.currkeyiv = aeskeyandiv;

		var eaes = this.rsa_encrypt(JSON.stringify(aeskeyandiv), currSessData.serverrsakey.pub_key);
		if (!this.isResponseArrSuccess(eaes))
			return eaes;

		//here check if password is really hashed this way

		currSessData.sessionrsakeypair = await this.rsa_generate_keypair();
		var sessiondata = this.createsessiondatainfos(recycleoldsessionid, null, null, null, currSessData.sessionrsakeypair.pubkey);

		var esessiondata = this.aes_encrypt(JSON.stringify(sessiondata), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);
		if (!this.isResponseArrSuccess(esessiondata))
			return esessiondata;

		var edata = this.getDataFromResponseArr(eaes) + ":::" + this.getDataFromResponseArr(esessiondata);

		return await this.communicateWithWebserver("create_session", currSessData.usercompany.Company_Short, null, edata)
			.then(eresponse => {
				if (this.isResponseArrSuccess(eresponse)) {
					var response = this.aes_decrypt(this.getDataFromResponseArr(eresponse), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);

					if (this.isResponseArrSuccess(response)) {
						var response_arr = JSON.parse(this.getDataFromResponseArr(response));
						currSessData.sessionid = response_arr.session_id;
						currSessData.sessionexpire = ABSUtils.NewDate(response_arr.expires);

						//nothing more to do here
						return this.makeSuccessArr();
					}
					else {
						//forget session
						currSessData.sessionid = null;
						currSessData.sessionexpire = null;
						currSessData.currkeyiv = null;
						currSessData.sessionrsakeypair = null;

						return response;
					}
				}
				else {
					//forget session
					currSessData.sessionid = null;
					currSessData.sessionexpire = null;
					currSessData.currkeyiv = null;
					currSessData.sessionrsakeypair = null;

					return eresponse;
				}
			})
			.catch(errorresponse => {
				//forget session
				currSessData.sessionid = null;
				currSessData.sessionexpire = null;
				currSessData.currkeyiv = null;
				currSessData.sessionrsakeypair = null;
				return app_error_createorvalidatecrash;
			});
	};

	createAndValidateSession = async (username, authenticationstring, authenticationtype, newaccesstoken = false) => {
		var recycleoldsessionid = null;

		var aeskeyandiv = this.aes_generate_key_and_iv();
		currSessData.currkeyiv = aeskeyandiv;

		var eaes = this.rsa_encrypt(JSON.stringify(aeskeyandiv), currSessData.serverrsakey.pub_key);
		if (!this.isResponseArrSuccess(eaes))
			return eaes;

		//here check if password is really hashed this way
		//but mind nfc could here be as well

		currSessData.sessionrsakeypair = await this.rsa_generate_keypair();
		var sessiondata = this.createsessiondatainfos(recycleoldsessionid, username, authenticationstring, authenticationtype, currSessData.sessionrsakeypair.pubkey);
		sessiondata.newaccesstoken = newaccesstoken;
		var esessiondata = this.aes_encrypt(JSON.stringify(sessiondata), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);
		if (!this.isResponseArrSuccess(esessiondata))
			return esessiondata;

		var edata = this.getDataFromResponseArr(eaes) + ":::" + this.getDataFromResponseArr(esessiondata);

		return await this.communicateWithWebserver("create_and_validate_session", currSessData.usercompany.Company_Short, null, edata)
			.then(eresponse => {
				if (this.isResponseArrSuccess(eresponse)) {
					var response = this.aes_decrypt(this.getDataFromResponseArr(eresponse), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);

					if (this.isResponseArrSuccess(response)) {
						var response_arr = JSON.parse(this.getDataFromResponseArr(response));
						currSessData.sessionid = response_arr.session_id;
						currSessData.sessionexpire = ABSUtils.NewDate(response_arr.expires);

						//set auth
						if (response_arr.accesstoken)
							currSessData.auth = this.createauthinfos(username, response_arr.accesstoken, response_arr.accesstokenexpire);

						//loginerror or licences and user infos
						return response_arr.responsetext;
					}
					else {
						//forget session
						currSessData.sessionid = null;
						currSessData.sessionexpire = null;
						currSessData.currkeyiv = null;
						currSessData.sessionrsakeypair = null;

						return response;
					}
				}
				else {
					//forget session
					currSessData.sessionid = null;
					currSessData.sessionexpire = null;
					currSessData.currkeyiv = null;
					currSessData.sessionrsakeypair = null;

					return eresponse;
				}
			})
			.catch(errorresponse => {

				//forget session
				currSessData.sessionid = null;
				currSessData.sessionexpire = null;
				currSessData.currkeyiv = null;
				currSessData.sessionrsakeypair = null;
				return app_error_createorvalidatecrash;
			});
	};

	validateSession = async (username, authenticationstring, authenticationtype, newaccesstoken = false) => {

		if (currSessData != null && currSessData.sessionrsakeypair != null && currSessData.currkeyiv != null && currSessData.sessionid != null) {
			//here check if password is really hashed this way

			var sessiondata = this.createsessiondatainfos(null, username, authenticationstring, authenticationtype, null);
			sessiondata.newaccesstoken = newaccesstoken;

			var dataarr = { data: JSON.stringify(sessiondata) };
			var esessiondata = this.aes_encrypt(JSON.stringify(dataarr), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);
			if (!this.isResponseArrSuccess(esessiondata))
				return esessiondata;

			var edata = this.getDataFromResponseArr(esessiondata);

			return await this.communicateWithWebserver("validate_session", currSessData.usercompany.Company_Short, currSessData.sessionid, edata)
				.then(eresponse => {
					if (this.isResponseArrSuccess(eresponse)) {
						var response = this.aes_decrypt(this.getDataFromResponseArr(eresponse), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);

						if (this.isResponseArrSuccess(response)) {
							var response_arr = JSON.parse(this.getDataFromResponseArr(response));

							//re-set expires, should be the same tho
							currSessData.sessionexpire = ABSUtils.NewDate(response_arr.expires);

							//set auth
							if (response_arr.accesstoken)
								currSessData.auth = this.createauthinfos(username, response_arr.accesstoken, response_arr.accesstokenexpire);

							//loginerror or licences and user infos
							return response_arr.responsetext;
						}
						else {
							//forget session
							currSessData.sessionid = null;
							currSessData.sessionexpire = null;
							currSessData.currkeyiv = null;
							currSessData.sessionrsakeypair = null;

							return response;
						}
					}
					else {
						//forget session
						currSessData.sessionid = null;
						currSessData.sessionexpire = null;
						currSessData.currkeyiv = null;
						currSessData.sessionrsakeypair = null;

						return eresponse;
					}
				})
				.catch(errorresponse => {
					//forget session
					currSessData.sessionid = null;
					currSessData.sessionexpire = null;
					currSessData.currkeyiv = null;
					currSessData.sessionrsakeypair = null;
					return app_error_createorvalidatecrash;
				});
		}
		else {
			return app_error_createorvalidatefailure;
		}
	};

	//needs to have a valid session (can be unauthenticated too) //data needs to be not json because it becomes json here
	communicationHandler = (apicall, data = null) => {
		return new Promise(async (resolve, reject) => {
			try {
				var retries = 0;
				do {
					if (!serverresponse_waiting) {
						retries = 33; //no retry
						serverresponse_waiting = true;

						var eresponse;
						//check if session exists
						if (this.isSessionValid()) {
							//check if session expired
							if (currSessData.sessionexpire <= new Date()) {
								eresponse = app_error_sessionexpired;
							}
							else {
								var dataarr = { data: JSON.stringify(data) };
								var edata = this.aes_encrypt(JSON.stringify(dataarr), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);
								if (!this.isResponseArrSuccess(edata)) {
									eresponse = edata;
								}
								else {
									eresponse = await this.communicateWithWebserver(apicall, currSessData.usercompany.Company_Short, currSessData.sessionid, this.getDataFromResponseArr(edata))
										.catch(errorresponse => {
											return errorresponse;
										});
								}
							}
						}
						else {
							eresponse = app_error_sessionnotexist;
						}

						if (this.isResponseArrSuccess(eresponse)) {
							serverresponse_waiting = false;
							var plain_response = this.aes_decrypt(this.getDataFromResponseArr(eresponse), currSessData.currkeyiv.key, currSessData.currkeyiv.iv);

							// Check if the decrypted data is actually an error response
							if (this.isResponseArrSuccess(plain_response)) {
								try {
									var decrypted_data = JSON.parse(this.getDataFromResponseArr(plain_response));
									// If the decrypted data is an error object, return it as an error
									if (decrypted_data && typeof decrypted_data === 'object' && decrypted_data.returnnumber != null && decrypted_data.returnnumber !== 0) {
										resolve(decrypted_data);
									} else {
										resolve(plain_response);
									}
								} catch (e) {
									// If parsing fails, just return the plain response
									resolve(plain_response);
								}
							} else {
								resolve(plain_response);
							}
						}
						else {
							//for debug
							if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
								//alert(JSON.stringify(eresponse));
							}

							//check if session problem, then reload, else give back error
							var errornumber = this.getNumberFromResponseArr(eresponse);
							if (errornumber == this.getNumberFromResponseArr(app_error_sessionexpired) || errornumber == this.getNumberFromResponseArr(app_error_sessionnotexist) || errornumber == 302 || errornumber == 303 || errornumber == 304 || errornumber == 305) {
								//create new session and only go on if success
								this.removeSessionCookie();
								await this.performAutoLogin(true)
									.then(userinfos => {
										//go on again
										serverresponse_waiting = false;
										retries = 0;
									})
									.catch(error => {
										//reload whole page
										serverresponse_waiting = false;
										location.reload(true);
									});
							}
							else if (errornumber == this.getNumberFromResponseArr(co_error_deviceversion)) {
								// API version mismatch error - reload automatically (also on login page if forwarded there)
								serverresponse_waiting = false;
								location.reload(true);
							}
							else {
								serverresponse_waiting = false;
								reject(eresponse);
							}
						}
					}

					await new Promise(r => setTimeout(r, 300));
					retries++;
				}
				while (retries < 33);

				reject(app_error_communicationhandlerbusy);
			}
			catch (error) {
				//for debug
				if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
					alert(error);
				}

				serverresponse_waiting = false;
				reject(app_error_communicationhandlercrash);
			}
		});
	};

	communicateWithWebserver = (apicall, codename, sessionid, apidata, connecttogateway = false) => {
		const locale = locales[i18next.language];
		var useablelocale = "de";
		if (locale != null) {
			switch (locale.code) {
				case "en-GB":
				case "enGB":
				case "en":
					useablelocale = "en";
					break;
				case "de-AT":
				case "deAT":
				case "de":
				default:
					useablelocale = "de";
					break;
			}
		}

		return new Promise(async (resolve, reject) => {
			try {
				var url;
				var apiversion;

				if (connecttogateway) {
					url = Broker1URL + "/" + brokerapifile;
					apiversion = webserviceversion_broker;
				}
				else if (currSessData != null && currSessData.usercompany != null && currSessData.usercompany.Referred_Server_URL != null && currSessData.usercompany.Referred_Server_URL != "127.0.0.1" && currSessData.usercompany.Referred_Server_URL.startsWith("https://")) {
					url = currSessData.usercompany.Referred_Server_URL + serverapifile;
					apiversion = webserviceversion_server;
				}
				else {
					reject(app_error_communicationrerror);
				}

				const apidetails = {
					devicelanguage: useablelocale,
					deviceversion: this.getSoftwareVersion(),
					deviceplatform: deviceplatform,
					nativeapp: this.getAppRestrictionCookie(),
					apiversion: apiversion,
					apicall: apicall,
					codename: codename,
					sessionid: sessionid,
				}

				var bodyData;
				if (currSessData.serverrsakey != null) {
					var encapidetails = this.rsa_aes_encrypt(JSON.stringify(apidetails));
					if (!this.isResponseArrSuccess(encapidetails))
						reject(encapidetails);
					bodyData = new URLSearchParams({
						apikeyid: currSessData.serverrsakey.key_id,
						apidetails: this.getDataFromResponseArr(encapidetails),
						apidata: apidata,
					});
				}
				else {
					bodyData = new URLSearchParams({
						apidetails: JSON.stringify(apidetails),
						apidata: apidata,
					});
				}
				const requestOptions = {
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
					},
					body: bodyData,
				};


				//since currently the webapp is only online, we can skip connection check here

				//now start the communication
				fetch(url, requestOptions)
					.catch(error => {
						//if catch then create error return
						var myBlob = new Blob();
						//for debug
						if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
							alert(error + " " + url);
						}

						var init = { "status": 400, "statusText": i18next.t("abswebservice:SERVERBADRESPONSE") };//+": " + error};
						return new Response(myBlob, init);
					})
					.then(response => {
						if (response.ok) {
							response.text()
								.catch(error => {
									//for debug
									if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
										alert(error);
									}

									reject(app_error_unknownserverresponse);
								})
								.then(data => {
									if (data.startsWith("{\"returnnumber\"")) {
										//success (does not mean its a success data)
										resolve(JSON.parse(data));
									}
									else {
										//for debug
										if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
											alert(data);
										}

										reject(app_error_unknownserverresponse);
									}
								});
						}
						else {
							//for debug
							if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
								alert(response.statusText);
							}

							reject(this.makeErrorArr(showonlytheerrortext, response.statusText));
						}
					});
			}
			catch (error) {
				//for debug
				if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
					alert(error);
				}

				reject(app_error_unknownserverresponse);
			}
		});
	};

	getServerToLocalTimeDiff = () => {
		if (currSessData.servertolocaltimediff != null) {
			return currSessData.servertolocaltimediff;
		}
		else
			return 0;
	};

	createsessiondatainfos = (sessionid, username, authentication, authenticationtype, sessionrsapubkey) => {
		return {
			sessionid: sessionid,
			username: username,
			authentication: authentication,
			authenticationtype: authenticationtype,
			sessionrsapubkey: sessionrsapubkey,
			programname: prgname,
			devicename: userPlatform.description,
			deviceplatform: userPlatform.name,
			deviceplatformversion: userPlatform.version,
			deviceidiom: userPlatform.os.toString(),
			deviceinternalip: userLocalIpUrl()
		};
	};
	createauthinfos = (username, accesstoken, accesstokenexpire) => {
		return {
			username: username,
			accesstoken: accesstoken,
			accesstokenexpire: accesstokenexpire
		};
	};

	//check if session ok - needs already company and server pub key
	performAutoLogin = (retryiffails = true) => {
		return new Promise(async (resolve, reject) => {
			//guard: NFC sessions have no auth data, so auto-login is not possible
			if (!currSessData.auth || !currSessData.auth.username || !currSessData.auth.accesstoken) {
				reject(app_error_sessionnotexist);
				return;
			}

			const sessioncookie = this.getSessionCookie();
			if (sessioncookie) {
				var abssession = JSON.parse(Buffer.from(sessioncookie, 'base64').toString("utf8"));
				currSessData.sessionid = abssession.sessionid;
				currSessData.sessionexpire = new Date(abssession.sessionexpire);
				currSessData.sessionrsakeypair = abssession.sessionrsakeypair;
				currSessData.currkeyiv = abssession.currkeyiv;
			}

			if (currSessData != null && currSessData.sessionrsakeypair != null && currSessData.currkeyiv != null && currSessData.sessionid != null && currSessData.sessionexpire != null && currSessData.sessionexpire >= new Date()) {
				var sessionresp = await this.validateSession(currSessData.auth.username, currSessData.auth.accesstoken, "Access_Token", false);
			}
			else {
				var sessionresp = await this.createAndValidateSession(currSessData.auth.username, currSessData.auth.accesstoken, "Access_Token", false);
			}

			if (this.isResponseArrSuccess(sessionresp)) {
				//save new or old session
				this.setSessionCookie(currSessData.sessionid, currSessData.sessionrsakeypair, currSessData.currkeyiv, currSessData.sessionexpire);

				var userinfos = JSON.parse(this.getDataFromResponseArr(sessionresp));
				userinfos.CompanyShortName = currSessData.usercompany.Company_Short;
				userinfos.CompanyName = currSessData.usercompany.companyrealname;
				userinfos.CompanyLogo = currSessData.usercompany.companylogo;

				//set allowed modules
				userinfos.modules = this.setAllowedModules(userinfos);

				//simulate absweb settings from user
				userinfos.Settings_ABSWeb = JSON.parse('{"uisettings":{"layout":{"config":{"navbar":{"folded":true}}}}}');

				//return the userinfos with modules
				resolve(userinfos);
			}
			else {
				this.removeSessionCookie();

				//check if we should retry
				if (retryiffails) {
					await this.performAutoLogin(false)
						.then(userinfos => {
							resolve(userinfos);
						})
						.catch(error => {
							reject(this.getDisplayTextFromResponseArr(error));
						});
				}
				else {
					reject(this.getDisplayTextFromResponseArr(sessionresp));
				}
			}
		});
	};

	setAllowedModules = userinfos => {
		var modules = ["loggedin"];

		//set default permissions
		if (userinfos.appliedpermissions.default.Can_manage_company_settings == 1 || userinfos.appliedpermissions.default.Can_view_user == 1 || userinfos.appliedpermissions.default.Can_manage_adminroles == 1 || userinfos.appliedpermissions.default.Hardware_admin == 1) {
			modules.push("abs_admin");
		}

		//set allowed modules
		if (userinfos.approvedmodules != null && userinfos.approvedmodules[0] != null) {
			Object.entries(userinfos.approvedmodules).forEach(([position, licence]) => {
				switch (licence.Module_name) {
					case "TimeLite":
						modules.push("tl_default");

						//check here permissions for tl
						if (userinfos.appliedpermissions.TL.Serversettings_admin == 1 || userinfos.appliedpermissions.TL.Status_admin == 1 || userinfos.appliedpermissions.TL.EPeriod_admin == 1 || userinfos.appliedpermissions.TL.Hierachy_admin == 1 || userinfos.appliedpermissions.TL.Object_admin == 1) {
							modules.push("abs_admin");
						}
						break;
					case "Exkursio":
						modules.push("eo_default");

						//check here permissions for eo
						if (userinfos.appliedpermissions.EO && (userinfos.appliedpermissions.EO.Serversettings_admin == 1 || userinfos.appliedpermissions.EO.Trips_admin == 1 || userinfos.appliedpermissions.EO.Vehicles_admin == 1)) {
							modules.push("abs_admin");
						}
						break;
					case "Persomat":
						modules.push("pm_default");
						break;
					case "BillBuddy":
						modules.push("bb_default");
						break;
					case "Inventurius":
						modules.push("iv_default");
						break;
				}
			});
		}

		//now only use single app if set
		var singleapp = this.getAppRestrictionCookie();
		switch (singleapp) {
			case "tl":
				modules = modules.filter((module) => module == "loggedin" || module.startsWith("tl_"))
				break;
			case "eo":
				modules = modules.filter((module) => module == "loggedin" || module.startsWith("eo_"))
				break;
		}

		return modules;
	}

	//rework this!!!
	updateUserData = user => {
		return new Promise((resolve, reject) => {
			reject("not implemented");
		});
	};

	getSoftwareVersion = () => {
		return "v" + deviceversion + "b" + deviceversionbuild;
	};

	getBackendVersion = () => {
		if (currSessData != null && currSessData.backendversion != null) {
			return currSessData.backendversion;
		}
		return null;
	};

	setSessionCookie = (sessionid, sessionrsakeypair, currkeyiv, sessionexpire) => {
		var cookieexpires;
		if (sessionexpire) {
			cookieexpires = sessionexpire;
		}

		var abssession = Buffer.from(JSON.stringify({ sessionid: sessionid, sessionrsakeypair: sessionrsakeypair, currkeyiv: currkeyiv, sessionexpire: sessionexpire }), 'utf8').toString("base64");

		cookies.set('abs_session', abssession, { path: '/', expires: cookieexpires, secure: false });
		//localStorage.setItem('abs_session', abssession);
	};
	removeSessionCookie = () => {
		cookies.remove('abs_session', { path: '/' });
		//localStorage.removeItem('abs_session');
	};
	getSessionCookie = () => {
		return cookies.get('abs_session');
		//return window.localStorage.getItem('abs_session');
	};
	setAccessTokenCookie = (username, accesstoken, accesstokenexpires = null) => {
		var cookieexpires;
		if (accesstokenexpires) {
			// let d = new Date();
			// d.setTime(d.getTime() + (30*24*60*60*1000)); //30 days
			cookieexpires = ABSUtils.NewDate(accesstokenexpires);
		}

		var abstoken = Buffer.from(JSON.stringify({ u: username, at: accesstoken }), 'utf8').toString("base64");

		cookies.set('abs_uat', abstoken, { path: '/', expires: cookieexpires, secure: false });
	};
	removeAccessTokenCookie = () => {
		cookies.remove('abs_uat', { path: '/' });
	};
	getAccessTokenCookie = () => {
		return cookies.get('abs_uat');
	};
	setCompanyCookie = (companyshortname) => {
		let d = new Date();
		d.setTime(d.getTime() + (90 * 24 * 60 * 60 * 1000)); //90 days

		cookies.set('abs_company', companyshortname, { path: '/', expires: d, secure: false });
	};
	getCompanyCookie = () => {
		return cookies.get('abs_company');
	};
	removeCompanyCookie = () => {
		cookies.remove('abs_company', { path: '/' });
	};
	//also gets checked manually on index.html
	getAppRestrictionCookie = () => {
		var singleapp = cookies.get('abs_nativeapp');
		//to avoid random values here
		switch (singleapp) {
			case "abs":
			case "tl":
			case "eo":
				return singleapp;
			default:
				return null;
		}
	};
	getNFCSupportCookie = () => {
		var nfc = cookies.get('abs_nfcsupport');
		//to avoid random values here
		switch (nfc) {
			case "android":
			case "ios":
				return nfc;
			default:
				return "none";
		}
	};

	getSystemMessages = () => {
		return currSessData.systemmessages || [];
	};

	// Login history storage functions for autocomplete suggestions
	getLoginHistory = () => {
		try {
			const history = localStorage.getItem('abs_login_history');
			if (history) {
				return JSON.parse(history);
			}
		} catch (e) {
			// Ignore parse errors
		}
		return { companies: [], users: {} };
	};

	saveLoginToHistory = (companyCodename, username) => {
		try {
			const history = this.getLoginHistory();

			// Save company codename (lowercase for consistency)
			const companyLower = companyCodename.toLowerCase();
			if (!history.companies.includes(companyLower)) {
				history.companies.push(companyLower);
				// Keep max 10 companies
				if (history.companies.length > 10) {
					history.companies.shift();
				}
			}

			// Save username per company
			if (!history.users[companyLower]) {
				history.users[companyLower] = [];
			}
			const usernameLower = username.toLowerCase();
			if (!history.users[companyLower].includes(usernameLower)) {
				history.users[companyLower].push(usernameLower);
				// Keep max 10 usernames per company
				if (history.users[companyLower].length > 10) {
					history.users[companyLower].shift();
				}
			}

			localStorage.setItem('abs_login_history', JSON.stringify(history));
		} catch (e) {
			// Ignore storage errors
		}
	};

	getCompanyHistory = () => {
		return this.getLoginHistory().companies || [];
	};

	getUsernameHistory = (companyCodename) => {
		if (!companyCodename) return [];
		const history = this.getLoginHistory();
		return history.users[companyCodename.toLowerCase()] || [];
	};

	deleteCurrentNativePushDevice = async () => {
		const token = await requestNativePushTokenOnly();
		if (!token || !this.isSessionValid()) return;

		await this.communicationHandler('abs_delete_push_device', { device_id: token })
			.catch(() => null);
	};

	logout = async () => {
		try {
			await this.deleteCurrentNativePushDevice();
		} catch (error) {
			// Logout must continue even if push-device cleanup fails.
		} finally {
			this.removeSessionCookie();
			this.removeAccessTokenCookie();
			localStorage.removeItem("absweb_responsivemessage");
			this.emit('onLogout');
		}
	};

	isTokenAndCompanyValid = async accesstokencookie => {
		if (!accesstokencookie) {
			return false;
		}
		var absuat = JSON.parse(Buffer.from(accesstokencookie, 'base64').toString("utf8"));
		if (absuat.u == null || absuat.at == null) {
			return false;
		}

		//here check if company is valid, else token is also not valid
		const companycookie = cookies.get('abs_company');
		if (!companycookie) {
			return false;
		}

		var errormessage = null;
		var returncontent = await this.getCompanyInfosAndPubKey(companycookie)
			.catch(errorresponse => {
				errormessage = errorresponse;
			});

		if (errormessage != null)
			return errormessage;

		if (returncontent.companyshortname != null) {
			//set the auth
			currSessData.auth = this.createauthinfos(absuat.u, absuat.at, null);

			//re-set the company cookie
			this.setCompanyCookie(returncontent.companyshortname);
			return true;
		}
		else //nodata here as well
		{
			this.removeCompanyCookie();
			return false;
		}
	};

	resetSessionUserData = () => {
		currSessData = {
			usercompany: null,
			serverrsakey: null,
			servertolocaltimediff: null,
			sessionrsakeypair: null,
			currkeyiv: null,
			sessionid: null,
			sessionexpire: null,
			auth: null
		};
	};

	isResponseArrSuccess = (arr) => {
		if (arr != null && arr?.returnnumber === 0) {
			return true;
		}
		else {
			return false;
		}
	};

	getDataFromResponseArr = (arr) => {
		if (arr?.returncontent != null) {
			var returndata = arr.returncontent;
		}
		else {
			var returndata = app_error_general.returncontent;
		}

		//translation
		if (returndata.startsWith("abswebservice:")) {
			returndata = i18next.t(returndata);
		}

		return returndata;
	};

	getNumberFromResponseArr = (arr) => {
		if (arr?.returnnumber != null) {
			return arr.returnnumber;
		}
		else {
			return app_error_general.returnnumber;
		}
	};

	makeSuccessArr = (content = "done") => {
		var arr = { returnnumber: success_general.returnnumber, returncontent: content };
		return arr;
	};

	makeErrorArr = (number, content) => {
		var arr = { returnnumber: number, returncontent: content };
		return arr;
	};

	getDisplayTextFromResponseArr = (arr) => {
		if (arr.returnnumber != null && arr.returncontent != null) {
			if (arr.returnnumber === showonlytheerrortext) {
				return this.getDataFromResponseArr(arr);
			}
			else {
				var returnvalue = "";
				if (arr.returnnumber != success_general.returnnumber) {
					returnvalue = i18next.t("abswebservice:ERROR") + ": " + this.getNumberFromResponseArr(arr) + " - " + this.getDataFromResponseArr(arr);
				}
				else {
					returnvalue = i18next.t("abswebservice:SUCCESS");
				}
				return returnvalue;
			}
		}
		else {
			return i18next.t("abswebservice:EMPTYVALUE");
			//return JSON.stringify(arr);
		}
	};
}

const instance = new absWebService();

export default instance;
